import React from "react";

import { Search } from "../page-components";

function SearchPage(props) {
  return <Search {...props} seoData={{ title: "Search" }} />;
}

export default SearchPage;
